export const translations = {
  en: {
    app_tagline: "Book recording & rehearsal studios by the hour",
    // auth
    welcome_back: "Welcome back",
    create_account: "Create your account",
    login: "Log in",
    signup: "Sign up",
    email: "Email",
    password: "Password",
    name: "Full name",
    continue_google: "Continue with Google",
    or: "or",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    i_am_a: "I am a",
    musician: "Musician",
    owner: "Studio Owner",
    logout: "Log out",
    demo_hint: "Demo: musician@studiosync.app / Music123!",
    // tabs
    tab_home: "Home",
    tab_map: "Map",
    tab_bookings: "Bookings",
    tab_profile: "Profile",
    // home
    find_studio: "Find your studio",
    search_placeholder: "Search by name, city…",
    all_types: "All types",
    recording: "Recording",
    rehearsal: "Rehearsal",
    with_engineer: "Sound engineer",
    max_price: "Max €/h",
    sort_by: "Sort",
    relevance: "Relevance",
    price_low: "Price: low to high",
    price_high: "Price: high to low",
    no_studios: "No public studios yet",
    no_studios_desc: "New studios must be verified by an admin before appearing here.",
    per_hour: "/hr",
    verified: "Verified",
    book_now: "Book now",
    view: "View",
    // studio detail / booking
    about: "About",
    amenities: "Equipment & amenities",
    select_date: "Select date",
    select_time: "Select hours",
    engineer_addon: "Add sound engineer",
    engineer_desc: "Pro engineer for your session",
    booking_summary: "Booking summary",
    studio_time: "Studio time",
    engineer_fee: "Engineer",
    total: "Total",
    hours: "hours",
    hour: "hour",
    pay_book: "Pay & book",
    processing: "Processing…",
    unavailable: "Booked",
    close: "Close",
    // bookings
    my_bookings: "My bookings",
    active: "Active",
    cancelled: "Cancelled",
    pending_payment: "Payment pending",
    no_bookings: "You have no bookings yet",
    cancel_booking: "Cancel",
    confirmed: "Confirmed",
    // profile
    profile_wallet: "Profile & Wallet",
    role_switch: "Account role",
    my_studios: "My studios",
    add_studio: "Add studio",
    wallet: "Wallet",
    available_balance: "Available balance",
    pending_balance: "Pending",
    withdraw: "Withdraw",
    withdraw_funds: "Withdraw funds",
    amount: "Amount",
    method: "Method",
    paypal: "PayPal",
    bank: "Bank transfer",
    destination: "Destination",
    paypal_email: "PayPal email",
    iban: "IBAN / account",
    request_withdraw: "Request withdrawal",
    withdrawals: "Withdrawal history",
    earnings: "Earnings",
    no_earnings: "No earnings yet",
    status_pending: "Pending verification",
    status_approved: "Approved · Public",
    status_rejected: "Rejected",
    // admin
    admin_panel: "Admin · Studio verification",
    pending_verification: "Pending verification",
    approve: "Approve",
    reject: "Reject",
    no_pending: "No studios pending verification",
    // create studio
    new_studio: "New studio listing",
    studio_name: "Studio name",
    type: "Type",
    description: "Description",
    city: "City",
    address: "Address",
    price_hour: "Price per hour (€)",
    open_hour: "Opens (h)",
    close_hour: "Closes (h)",
    offer_engineer: "Offer sound engineer service",
    engineer_rate: "Engineer rate per hour (€)",
    cover_image: "Cover image",
    submit_listing: "Submit for verification",
    listing_created: "Studio submitted — pending admin verification",
    // map
    studios_map: "Studios map",
    map_hint: "Showing verified public studios",
    // misc
    save: "Save",
    saved: "Saved",
    payment_success: "Payment successful! Your booking is confirmed.",
    payment_cancelled: "Payment cancelled.",
    back_to_app: "Back to app",
    kyc_required: "Verify your identity (KYC) before booking",
    verifying_payment: "Verifying payment…",
    reviews: "Reviews",
    write_review: "Write a review",
    your_rating: "Your rating",
    submit_review: "Submit review",
    review_added: "Review submitted",
    no_reviews: "No reviews yet",
    only_booked_review: "You can only review studios you've booked",
    upload_photo: "Upload photo",
    uploading: "Uploading…",
    or_choose_preset: "or choose a preset",
    owner_bookings: "Incoming bookings",
    no_incoming: "No bookings for your studios yet",
    booked_by: "Booked by",
    payment_method: "Payment method",
    pay_card: "Card",
    pay_cash: "Cash at studio",
    card_fee: "Card management fee",
    cash_note: "Pay in cash directly at the studio. Booking confirmed instantly.",
    booking_confirmed: "Booking confirmed!",
    account_name: "Account holder name",
    swift: "SWIFT / BIC",
    equipment: "Equipment",
    equipment_hint: "Microphone, sound card, monitors… (comma separated)",
    engineer_bio: "Engineer bio",
    engineer_bio_hint: "e.g. I've worked with…",
    engineer_photo: "Engineer photo",
    mark_collected: "Mark as collected",
    collected: "Collected",
    edit_studio: "Edit studio",
    save_changes: "Save changes",
    listing_updated: "Studio updated",
    all_studios: "All studios",
    photos: "Photos",
    account_type: "Account type",
    my_profile: "My profile",
    artist_name: "Artist name",
    real_name: "Real name",
    phone: "Phone",
    bio: "Bio",
    avatar: "Profile photo",
    save_profile: "Save profile",
    kyc: "Identity verification (KYC)",
    kyc_unverified: "Not verified",
    kyc_pending: "Under review",
    kyc_verified: "Verified",
    kyc_rejected: "Rejected",
    upload_id: "Upload ID document",
    submit_kyc: "Submit for verification",
    kyc_submitted: "KYC submitted for review",
    income_panel: "Monthly income by studio",
    no_income: "No income yet",
    income_total: "Total",
    kyc_admin: "KYC verification",
    verify: "Verify",
    kyc_banner: "Verify your identity to start booking studios",
    kyc_banner_cta: "Go to Profile to verify",
    register: "Sign up",
    signup_to_book: "Sign up or log in to book",
    auth_prompt: "Sign up or log in to access this section",
    commission_earned: "Management commission collected",
    commission_available: "Available to withdraw",
    commission_withdrawals: "Commission withdrawals",
    manage_withdrawals: "Withdrawal requests",
    mark_paid: "Mark paid",
    wd_requested: "Requested",
    wd_completed: "Paid",
    wd_rejected: "Rejected",
    commission_label: "Commission",
    wallet_label: "Owner",
    verify_with_didit: "Verify with Didit",
    kyc_didit_hint: "Verify your identity securely with Didit to start booking.",
    check_status: "Check status",
    tab_contact: "Contact",
    contact_title: "Contact us",
    contact_intro: "Any question? Send us a message and we'll reply by email.",
    contact_name: "Your name",
    contact_email: "Your email",
    contact_message: "Message",
    contact_send: "Send message",
    contact_sent: "Message sent — we'll get back to you soon",
    contact_phone: "Contact phone",
    contact_phone_hint: "Sent by email to musicians who book (for cash payments & questions)",
  },
  es: {
    app_tagline: "Reserva estudios de grabación y ensayo por horas",
    welcome_back: "Bienvenido de nuevo",
    create_account: "Crea tu cuenta",
    login: "Iniciar sesión",
    signup: "Registrarse",
    email: "Correo",
    password: "Contraseña",
    name: "Nombre completo",
    continue_google: "Continuar con Google",
    or: "o",
    no_account: "¿No tienes cuenta?",
    have_account: "¿Ya tienes cuenta?",
    i_am_a: "Soy",
    musician: "Músico",
    owner: "Dueño de estudio",
    logout: "Cerrar sesión",
    demo_hint: "Demo: musician@studiosync.app / Music123!",
    tab_home: "Inicio",
    tab_map: "Mapa",
    tab_bookings: "Reservas",
    tab_profile: "Perfil",
    find_studio: "Encuentra tu estudio",
    search_placeholder: "Busca por nombre, ciudad…",
    all_types: "Todos los tipos",
    recording: "Grabación",
    rehearsal: "Ensayo",
    with_engineer: "Con técnico",
    max_price: "Máx €/h",
    sort_by: "Ordenar",
    relevance: "Relevancia",
    price_low: "Precio: menor a mayor",
    price_high: "Precio: mayor a menor",
    no_studios: "Aún no hay estudios públicos",
    no_studios_desc: "Los estudios nuevos deben ser verificados por un admin antes de aparecer aquí.",
    per_hour: "/h",
    verified: "Verificado",
    book_now: "Reservar",
    view: "Ver",
    about: "Descripción",
    amenities: "Equipo y servicios",
    select_date: "Selecciona fecha",
    select_time: "Selecciona horas",
    engineer_addon: "Añadir técnico de sonido",
    engineer_desc: "Técnico profesional para tu sesión",
    booking_summary: "Resumen de reserva",
    studio_time: "Tiempo de estudio",
    engineer_fee: "Técnico",
    total: "Total",
    hours: "horas",
    hour: "hora",
    pay_book: "Pagar y reservar",
    processing: "Procesando…",
    unavailable: "Ocupado",
    close: "Cerrar",
    my_bookings: "Mis reservas",
    active: "Activas",
    cancelled: "Canceladas",
    pending_payment: "Pago pendiente",
    no_bookings: "Todavía no tienes reservas",
    cancel_booking: "Cancelar",
    confirmed: "Confirmada",
    profile_wallet: "Perfil y Cartera",
    role_switch: "Rol de cuenta",
    my_studios: "Mis estudios",
    add_studio: "Añadir estudio",
    wallet: "Cartera",
    available_balance: "Saldo disponible",
    pending_balance: "Pendiente",
    withdraw: "Retirar",
    withdraw_funds: "Retirar fondos",
    amount: "Importe",
    method: "Método",
    paypal: "PayPal",
    bank: "Transferencia bancaria",
    destination: "Destino",
    paypal_email: "Correo de PayPal",
    iban: "IBAN / cuenta",
    request_withdraw: "Solicitar retiro",
    withdrawals: "Historial de retiros",
    earnings: "Ingresos",
    no_earnings: "Aún no hay ingresos",
    status_pending: "Pendiente de verificación",
    status_approved: "Aprobado · Público",
    status_rejected: "Rechazado",
    admin_panel: "Admin · Verificación de estudios",
    pending_verification: "Pendientes de verificación",
    approve: "Aprobar",
    reject: "Rechazar",
    no_pending: "No hay estudios pendientes de verificación",
    new_studio: "Nuevo estudio",
    studio_name: "Nombre del estudio",
    type: "Tipo",
    description: "Descripción",
    city: "Ciudad",
    address: "Dirección",
    price_hour: "Precio por hora (€)",
    open_hour: "Abre (h)",
    close_hour: "Cierra (h)",
    offer_engineer: "Ofrecer servicio de técnico de sonido",
    engineer_rate: "Tarifa técnico por hora (€)",
    cover_image: "Imagen de portada",
    submit_listing: "Enviar para verificación",
    listing_created: "Estudio enviado — pendiente de verificación admin",
    studios_map: "Mapa de estudios",
    map_hint: "Mostrando estudios públicos verificados",
    save: "Guardar",
    saved: "Guardado",
    payment_success: "¡Pago realizado! Tu reserva está confirmada.",
    payment_cancelled: "Pago cancelado.",
    back_to_app: "Volver a la app",
    kyc_required: "Verifica tu identidad (KYC) antes de reservar",
    verifying_payment: "Verificando pago…",
    reviews: "Reseñas",
    write_review: "Escribe una reseña",
    your_rating: "Tu valoración",
    submit_review: "Enviar reseña",
    review_added: "Reseña enviada",
    no_reviews: "Aún no hay reseñas",
    only_booked_review: "Solo puedes reseñar estudios que hayas reservado",
    upload_photo: "Subir foto",
    uploading: "Subiendo…",
    or_choose_preset: "o elige una predeterminada",
    owner_bookings: "Reservas entrantes",
    no_incoming: "Aún no hay reservas en tus estudios",
    booked_by: "Reservado por",
    payment_method: "Método de pago",
    pay_card: "Tarjeta",
    pay_cash: "Efectivo en el estudio",
    card_fee: "Comisión de gestión (tarjeta)",
    cash_note: "Paga en efectivo directamente en el estudio. Reserva confirmada al instante.",
    booking_confirmed: "¡Reserva confirmada!",
    account_name: "Nombre del titular",
    swift: "SWIFT / BIC",
    equipment: "Equipo",
    equipment_hint: "Micrófono, tarjeta de sonido, monitores… (separado por comas)",
    engineer_bio: "Sobre el ingeniero",
    engineer_bio_hint: "ej. He trabajado con…",
    engineer_photo: "Foto del ingeniero",
    mark_collected: "Marcar como cobrada",
    collected: "Cobrada",
    edit_studio: "Editar estudio",
    save_changes: "Guardar cambios",
    listing_updated: "Estudio actualizado",
    all_studios: "Todos los estudios",
    photos: "Fotos",
    account_type: "Tipo de cuenta",
    my_profile: "Mi perfil",
    artist_name: "Nombre artístico",
    real_name: "Nombre real",
    phone: "Teléfono",
    bio: "Biografía",
    avatar: "Foto de perfil",
    save_profile: "Guardar perfil",
    kyc: "Verificación de identidad (KYC)",
    kyc_unverified: "Sin verificar",
    kyc_pending: "En revisión",
    kyc_verified: "Verificado",
    kyc_rejected: "Rechazado",
    upload_id: "Subir documento de identidad",
    submit_kyc: "Enviar para verificación",
    kyc_submitted: "KYC enviado a revisión",
    income_panel: "Ingresos mensuales por estudio",
    no_income: "Aún no hay ingresos",
    income_total: "Total",
    kyc_admin: "Verificación KYC",
    verify: "Verificar",
    kyc_banner: "Verifica tu identidad para empezar a reservar estudios",
    kyc_banner_cta: "Ve a Perfil para verificarte",
    register: "Registrarse",
    signup_to_book: "Regístrate o inicia sesión para reservar",
    auth_prompt: "Regístrate o inicia sesión para acceder a esta sección",
    commission_earned: "Comisión de gestión acumulada",
    commission_available: "Disponible para retirar",
    commission_withdrawals: "Retiros de comisión",
    manage_withdrawals: "Solicitudes de retiro",
    mark_paid: "Marcar pagada",
    wd_requested: "Solicitada",
    wd_completed: "Pagada",
    wd_rejected: "Rechazada",
    commission_label: "Comisión",
    wallet_label: "Dueño",
    verify_with_didit: "Verificar con Didit",
    kyc_didit_hint: "Verifica tu identidad de forma segura con Didit para empezar a reservar.",
    check_status: "Comprobar estado",
    tab_contact: "Contacto",
    contact_title: "Contáctanos",
    contact_intro: "¿Alguna duda? Envíanos un mensaje y te responderemos por correo.",
    contact_name: "Tu nombre",
    contact_email: "Tu correo",
    contact_message: "Mensaje",
    contact_send: "Enviar mensaje",
    contact_sent: "Mensaje enviado — te responderemos pronto",
    contact_phone: "Teléfono de contacto",
    contact_phone_hint: "Se envía por correo al músico que reserva (para pagos en efectivo y dudas)",
  },
};

export function detectLang() {
  const stored = localStorage.getItem("studio_sync_lang");
  if (stored === "en" || stored === "es") return stored;
  const nav = (navigator.language || navigator.userLanguage || "en").toLowerCase();
  return nav.startsWith("es") ? "es" : "en";
}
